import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LiveToggleWrapper } from './styles';
import Label from '../../../../components/shared/Label';
import IconFont from '../../../../components/shared/IconFont';
import { EVENT_FRAME1_NAME } from '../../../../components/adv/Frame1Mobile';
import { getQuery } from '../../../../helpers';

class LiveToggle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      live: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const query = getQuery(document.location) || null;
    if (query && typeof query.showLive !== 'undefined' && nextProps.liveCounter > 0 && this.props.liveCounter !== nextProps.liveCounter) {
      this.setState({
        live: true,
      });
      this.props.liveChange(true);
    }
  }

  handleLiveChange = () => {
    document.dispatchEvent(new Event(EVENT_FRAME1_NAME));
    if ((this.props.filterDate.get('value') === 'today') && (this.props.liveCounter !== 0)) {
      this.setState({
        live: !this.state.live,
      });
      this.props.liveChange(!this.state.live);
      if (process.env.REACT_APP_SITE !== 'corriere') {
        !this.state.live && window.omniture && window.omniture.trkEventMc('Matchcenter box Live');
      }
    }
  };

  render() {
    const dc = this.props.dictionary;
    return (
      <LiveToggleWrapper
        onClick={this.handleLiveChange}
        isToday={this.props.filterDate.get('value') === 'today'}
        liveCounter={this.props.liveCounter}
        bgColor={this.state.live ? 'liveColor' : 'white'}
      >
        <IconFont
          withCursor
          className={this.state.live ? 'icon-matchcenter-checked-box' : 'icon-matchcenter-uncheck-box'}
          color={this.state.live ? 'black' : 'lightGray'}
          font={15}
          marginLeft={0.4}
          borderRadius={10}
          bgColor="white"
        />
        <Label
          label={dc.live.toUpperCase()}
          color={this.props.liveCounter ? (this.state.live ? 'white' : 'liveColor') : 'lightGray'}
          margin="0.6em"
          size={0.85}
          lineHeight={1}
          alignSelf="baseline"
          isTitleNarrowMedium
        />
      </LiveToggleWrapper>
    );
  }
}

LiveToggle.propTypes = {
  dictionary: PropTypes.any,
  filterDate: PropTypes.any,
  liveChange: PropTypes.any,
  liveCounter: PropTypes.any,
};

export default LiveToggle;
